import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class MoveArbetsorderOperationCommand extends BasicCommand<MoveArbetsorderOperationCommand> {
    get primaryKey(): IPrimaryKey<MoveArbetsorderOperationCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    operationId: number;
    startdatum: Date;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "MoveArbetsorderOperationCommand";
    constructor(init: (instance: MoveArbetsorderOperationCommand) => void) {
        super(MoveArbetsorderOperationCommand.$type, MoveArbetsorderOperationCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
